import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'material-ui';
import { Route } from 'react-router-dom';

import SalesReport from './Sales';
import AdminReport from './Admin';

export default class Reports extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        selectedTab: PropTypes.string,
      }),
    }),
    history: PropTypes.shape().isRequired,
  }

  static defaultProps = {
    match: { params: { selectedTab: 'admin' } },
  }

  constructor(props) {
    super(props);

    const { match: { params: { selectedTab } } } = props;

    this.state = { selectedTab };
  }

  handleChange = (selectedTab) => {
    const { history } = this.props;
    this.setState({ selectedTab });
    history.push(`/reports/${selectedTab}/`);
  };

  render() {
    const { selectedTab } = this.state;

    return (<div>
      <Tabs value={selectedTab} onChange={this.handleChange}>
        <Tab label='Admin Report' value='admin'><AdminReport /></Tab>
        <Tab label='Sales Report' value='sales'><Route path='/reports/sales/' component={SalesReport} /></Tab>
      </Tabs>
    </div>);
  }
}



// WEBPACK FOOTER //
// /src/components/Reports/Reports.js